import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function NewYearCelebrations20261231() {

    const images = [
        "IMG_20251231_152453.jpg",
        "IMG_20251231_152531.jpg",
        "12_31_2025_01_26_34_pm.jpg",
        "12_31_2025_01_36_17_pm.jpg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        New Year 2026 Celebrations – 31st December, 2025
                                    </h2>

                                    <p>
                                        SWEC celebrated the arrival of <strong>New Year 2026</strong> with great joy and
                                        enthusiasm on <strong>31st December, 2025</strong>. The campus was filled with
                                        festive spirit as students and faculty came together to mark the occasion.
                                    </p>

                                    <p>
                                        The celebrations featured vibrant moments of togetherness, cheer, and reflection,
                                        creating memorable experiences for everyone present.
                                    </p>

                                    <p>
                                        Wishing all students, faculty, and staff a happy, successful, and prosperous
                                        New Year 2026!
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/New-Year-2026-Celebrations/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/New-Year-2026-Celebrations/${img}`}
                                                            alt={`New Year Celebration Image ${index + 1}`}
                                                            className="img-responsive center-block rounded overflow-hidden"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default NewYearCelebrations20261231;
